import type {PerkIntegrationStruct} from '@cohort/shared/schema/apps/app';
import {Apps} from '@cohort/wallet/apps';
import type {PerkIntegration} from '@cohort/wallet/apps/PerkIntegration';
import {useCallback} from 'react';

export type Output<T extends PerkIntegrationStruct> = {
  getPerkIntegration: (perkIntegrationId: T['Id']) => PerkIntegration<T>;
};

export const usePerkIntegrations = <T extends PerkIntegrationStruct>(): Output<T> => {
  const getPerkIntegration = useCallback((perkIntegrationId: T['Id']): PerkIntegration<T> => {
    const appId = perkIntegrationId.split('.')[0];
    const app = Apps.find(app => app.spec.id === appId);
    if (!app) {
      throw new Error(`No App found for id: ${appId}`);
    }
    const perkIntegration = app.perkIntegrations.find(
      integration => integration.spec.id === perkIntegrationId
    );
    if (!perkIntegration) {
      throw new Error(`No PerkIntegration found for perkIntegrationId: ${perkIntegrationId}`);
    }
    return perkIntegration as PerkIntegration<T>;
  }, []);

  return {
    getPerkIntegration,
  };
};
